// extracted by mini-css-extract-plugin
export default {"cardMedia":"z4-z","shopText":"A4-z","videoPlayer":"B4-z","videoContainer":"C4-z"};